import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import SimulationFlowSettings1 from "./SimulationFlowSettings1.mjs";
import SimulationFlowSettings2 from "./SimulationFlowSettings2.mjs";
import {Button, ButtonGroup} from "reactstrap";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import AppWarningIcon from "../../../media/app-images/AppWarningIcon.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import "./SimulationFlowSettings.css";
import appLib from "../../../libs/appLib.mjs";

const prefix = "SimulationFlowSettings";

const SimulationFlowSettings = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			update: Date.now(),
			changed: false,
			canSave: false,
			status: props.simul.status,
			did: {
				info: (props.simul.status >= 10),
				settings: (props.simul.status >= 40),
				run: ( props.simul.status >= 50),
				over: ( props.simul.status >= 80),
				report: ( props.simul.status >= 90),
			}
		};
		this.uid = Glob.generateUid(prefix);
		this.panel = this.panel.bind(this);
		this.save = this.save.bind(this);
	}
	panel(upd) {
		const props = {
			updateTime: upd ?? this.state.update,
			save: this.save,
			status: this.state.status,
			simul: Glob.clone( this.props.simul ),
			peri: this.props.simul?.info?.peri,
			did: this.state.did,
			changed: x => { this.setState({ changed: x, canSave: true }); },
			canSave: x => { this.setState({ canSave: x }); },
		}
		switch (this.props.simul?.info?.type) {
			case 1: return <SimulationFlowSettings1 {...props} />;
			case 2: return <SimulationFlowSettings2 {...props} />;
			default: return null;
		}
	}
	save() {
		const data = this.state.changed;
		appLib.api('simul/trigger', { id: this.props.simul.id, trigger: data } ).then( this.props.afterSave );
	}
	render() {
		return(
			<>
				<div className={"panel-content "+prefix}>
					<h3 className={"limited"}>
						<TextLabel value={"SimulationSettings"} />
					</h3>
					{ this.panel( this.state.update ) }
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={ ()=>{ Glob.setCurrentPageParam('step','info') }}
						>
							<i>
								{ this.state.canSave ? <AppWarningIcon /> : <ChevronLeftIcon /> }
							</i>
							<b>
								<TextLabel value={"Info"} />
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						{ (! this.state.did.run) && (
							<Button
								color={"primary"}
								disabled={ ! this.state.canSave }
								onClick={ this.save }
							>
								<i>
									<CheckIcon />
								</i>
								<b>
									<TextLabel value={"Save"} />
								</b>
							</Button>
						)}
						<Button
							disabled={ ! this.state.did.settings }
							color={"success"}
							onClick={ ()=>{ Glob.setCurrentPageParam('step','ready') }}
						>
							<b>
								<TextLabel value={"Simulation start"} />
							</b>
							<i>
								{ this.state.canSave ? <AppWarningIcon /> : <ChevronRightIcon /> }
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		);
	}
}

export default SimulationFlowSettings;